import React from "react"
import { Checkbox, Table } from "react-bootstrap"

export default function ClientDocuments({ documents }) {

  documents = (documents && documents.length) ? documents : [];
  const centerCenter = 'align-center v-center'

  const renderTh = (name, title) => <th className={ centerCenter } title={ title }><small>{ name }</small></th>

  const renderTd = content => <td className={ centerCenter }>{ content }</td>

  const data = documents.map((item, index) => <tr key={`customerInfo-${index}`}
    title="Item">
    { renderTd(item.label) }
    { renderTd(<small>{ item.imageType }</small>) }
    { renderTd(<Checkbox checked={ item.mandatory } readOnly></Checkbox>) }
  </tr>)

  return (
    <Table striped condensed hover responsive>
      <caption>Documents</caption>
      <thead>
        <tr>
          { renderTh('LABEL') }
          { renderTh('IMAGE TYPE') }
          { renderTh('REQUIRED', 'The field is mandatory?') }
        </tr>
      </thead>
      <tbody>
        { data }
      </tbody>
    </Table>
  )
}



// WEBPACK FOOTER //
// ./src/components/fragments/ClientDocuments.js